import Project from '../../component/Project';
import worldTradeCentreData from '../../data/SoharChinaDowntown.json';
const SoharChinaDowntown = () => {
  const { pageData, containerData, content, images, styles } = worldTradeCentreData;
  return (
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
 )
}

export default SoharChinaDowntown
